// extracted by mini-css-extract-plugin
export var paginationContainer = "_71-0";